import MuiTab from '@mui/material/Tab';
import { styled } from '@mui/system';
import colors from '../../../assets/colors';

const StyledTab = styled(MuiTab)(({ theme }) => ({
  backgroundColor: colors.oldAgroweGreen,
  opacity: 0.8,
  textTransform: 'none',
  minWidth: '20%',
  fontWeight: theme.typography.fontWeightBold,
  fontSize: 32,
  marginRight: theme.spacing(4),
  color: colors.white,
  '&:hover': {
    color: colors.white,
    opacity: 0.5,
  },
  '&.Mui-selected': {
    color: colors.white,
    fontWeight: theme.typography.fontWeightBold,
  },
  '&:focus': {
    color: colors.white,
    fontWeight: theme.typography.fontWeightBold,
  },
}));

const Tab = (props) => <StyledTab disableRipple {...props} />;
export default Tab;
